import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=5252737a&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=5252737a&prod&scoped=true&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=5252737a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5252737a",
  null
  
)

export default component.exports